// Styles
import './Categories.scss';

// Libs
import React, { useMemo } from 'react';

// Blocks
import Option from '@/ebat/components/blocks/Forms/SelectGroup/Option/Option';

import {
  CategoriesDefaultProps,
  CategoriesPropTypes,
} from './Categories.proptypes';

const Categories = ({
  children,
  className,
  disabled,
  name,
  onChange,
  title,
  wishlists,
}) => {
  /**
   * Generate classNames
   * @type {string}
   */
  const classNames = useMemo(
    () => ['select-group-categories', className].filter((val) => val).join(' '),
    [className],
  );

  return (
    <div className={classNames}>
      <span className="select-group-categories__label">{title}</span>
      <ul className="select-group-categories__list">
        {wishlists.map((wishlist) => (
          <li
            className="select-group-categories__item"
            key={`select-group-categories-item-${wishlist.id}`}
          >
            <Option
              active={wishlist.active}
              count={wishlist.item_count}
              disabled={disabled}
              name={name}
              onChange={onChange}
              title={wishlist.name}
              value={wishlist.id}
            />
          </li>
        ))}
      </ul>
      {children}
    </div>
  );
};

Categories.defaultProps = {
  ...CategoriesDefaultProps,
};

Categories.propTypes = {
  ...CategoriesPropTypes,
};

export default Categories;
